import React from "react";
import { Box, CircularProgress } from "@mui/material";

const CargandoDatos = () => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default CargandoDatos;